module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Component-f8368fa5ba44f0771f5d1749307d84f0.svg";